import React from 'react';
import { Box, Button, Card, CardContent, CardHeader, Divider, TextField, CardActions, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const passwordTitle = "Change Password";
const passwordSubTitle = ""

export const PasswordChange = (props) => {
  const setMessage = props.setMessage;
  const setSeverity = props.setSeverity;
  const [match, setMatch] = React.useState(false);
  const [values, setValues] = React.useState({
    password: '',
    confirm: ''
  });
  const [oldPassword, setOldPassword] = React.useState('');

  const handleChange = (event) => {

    const { name, value } = event.target;
    if (name === 'password' || name === 'confirm') {
      setValues({
        ...values,
        [event.target.name]: event.target.value
      });
    }else if (name === 'oldPassword') {
      // If the changed field is the old password, update the oldPassword state
      setOldPassword(value);
    }
  };

  React.useEffect(() => {
    const hasCapitalLetter = /[A-Z]/.test(values.password);
    const hasNumber = /\d/.test(values.password);

    if("" === values.password) setMatch(false);
    if("" === values.confirm) setMatch(false);
    if(values.password.length < 6  || !hasCapitalLetter || !hasNumber) setMatch(false);
    else setMatch(values.password === values.confirm);
  },[values])

  const clear = () => {
    setValues({password:"",confirm:""});
    setOldPassword("");
  }

  const submit = async (values) => {
    const requestBody = {
      oldPassword: oldPassword,
      newPassword: values.password
    };
    const res = await fetch(process.env.REACT_APP_API_HOST + '/account/changePassword', {
      method: 'POST', // or 'PUT'
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody), //values
    })
    res.json().then(res => {
      if (res.success) {
        clear();
        setMessage("Password Changed");
        setSeverity("success");
      } else {
        setMessage("Password Change Failed: " + res.exception);
        setSeverity("warning");
      }
    })
  }

  return (
    <form>
      <Card>
        <CardHeader
          title={passwordTitle}
          subheader="Password must be at least six characters long, contain at least one uppercase letter, and contain at least one number."
        />
        <CardContent>
        <VisibilityControlledPasswordField
            fullWidth
            label="Old Password"
            margin="normal"
            name="oldPassword"
            onChange={handleChange}
            type="password"
            value={oldPassword}
            variant="outlined"
          />
          <VisibilityControlledPasswordField
            fullWidth
            label="New Password"
            margin="normal"
            name="password"
            onChange={handleChange}
            type="password"
            value={values.password}
            variant="outlined"
          />
          <VisibilityControlledPasswordField
            fullWidth
            label="Confirm Password"
            margin="normal"
            name="confirm"
            onChange={handleChange}
            type="password"
            value={values.confirm}
            variant="outlined"
          />
        </CardContent>
        <Divider />
        <CardActions sx={{m:1}}>
          <Button
            color="primary"
            variant="contained"
            disabled={!match}
            onClick={() => submit(values) }          >
            Update
          </Button>
          <Button
            color="secondary"
            variant="contained"
            disabled={values.password===""&&values.confirm===""}
            onClick={() => clear()}
          >
            Cancel
          </Button>
        </CardActions>
      </Card>
    </form>
  );
};


const VisibilityControlledPasswordField = (props) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const label = props.label;
  return (
      <div>
          <TextField
              {...props}
              label={label}
              variant="outlined"
              type={showPassword ? "text" : "password"}
              InputProps={{
                  endAdornment: (
                      <InputAdornment position="end">
                          <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                          >
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                      </InputAdornment>
                  ),
              }}
              InputLabelProps={{
                  shrink: true,
              }}
          /></div>
  )
}